import {
  FloatingLinkType,
  useFloatingLinkEdit,
} from 'lib-knowledge-document-structure';

import { AnchorLinkDetails } from './anchorLinkDetails';
import { InterlinkDetails } from './interlinkDetails';
import { UrlLinkDetails } from './urlLinkDetails';

type LinkDetailsProps = {
  linkType: FloatingLinkType;
  editButtonProps: ReturnType<typeof useFloatingLinkEdit>['editButtonProps'];
  unlinkButtonProps: ReturnType<
    typeof useFloatingLinkEdit
  >['unlinkButtonProps'];
};

export function LinkDetails({
  linkType,
  editButtonProps,
  unlinkButtonProps,
}: LinkDetailsProps): JSX.Element {
  if (linkType === 'anchor') {
    return (
      <AnchorLinkDetails
        editButtonProps={editButtonProps}
        unlinkButtonProps={unlinkButtonProps}
      />
    );
  }

  if (linkType === 'article') {
    return (
      <InterlinkDetails
        editButtonProps={editButtonProps}
        unlinkButtonProps={unlinkButtonProps}
      />
    );
  }

  return (
    <UrlLinkDetails
      editButtonProps={editButtonProps}
      unlinkButtonProps={unlinkButtonProps}
    />
  );
}
